import { ReactElement, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import DeleteIcon from "../../../assets/images/Delete.svg";
import { Image } from "../../../components/elements";
import { useCartActions } from "../../../contexts/CartServiceContext/CartServiceContext";
import ClearAllCartModal from "../ClearAllCartModal/ClearAllCartModal";

const ClearAll = (): ReactElement => {
	const actions = useCartActions();
	const [openConfirmCleanModal, setOpenConfirmCleanModal] = useState(false);
	const { t } = useTranslation();

	const handleClickConfirm = useCallback(() => {
		actions.CLEAN_CART();
		setOpenConfirmCleanModal(false);
	}, [setOpenConfirmCleanModal]);
	const onClick = useCallback(() => {
		setOpenConfirmCleanModal(true);
	}, [setOpenConfirmCleanModal]);
	const onCancel = useCallback(() => {
		setOpenConfirmCleanModal(false);
	}, [setOpenConfirmCleanModal]);

	return (
		<>
			<button key="clean-cart" className="ClearAllButton" onClick={onClick}>
				<Image src={DeleteIcon} alt="DeleteIcon" className="DeleteIcon" />
				{t("cartPage.clearAll")}
			</button>
			<ClearAllCartModal
				onClose={handleClickConfirm}
				onCancel={onCancel}
				open={openConfirmCleanModal}
				onConfirm={handleClickConfirm}
			/>
		</>
	);
};

export default ClearAll;
